export default {
  aboutapp: {
    subtitle: "معلومات عنا",

    title: "مرحبًا بكم في متجر المنتجات الزراعية العضوية",

    desc:
      "هناك العديد من النصوص المتاحة، لكن معظمها تعرض للتعديل أو التغيير بشكل ما.",

    item1: "منتجات عضوية عالية الجودة",
    item2: "طعام صحي يوميًا",
    item3: "نمو محلي للأغذية الطازجة",
    item4: "تجربة مميزة وممتعة",

    cta: "ابدأ باستخدام محل اليوم",

    quote:
      "“هناك العديد من النصوص المتاحة، لكن معظمها تعرض للتعديل”",

    author: "روبرت داي",
  },
};